import { t } from "../../services/formatters";
import { Consenso } from "../Consenso";
import { useSession } from "../../hooks/useSession";
import { informative } from "./informative";
import closeIcon from "../../assets/imgs/close-modal-icon.svg";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { useRef, useState } from "react";
import "./style.css";

export const Informative = ({}) => {
    const { read, update } = useSession();

    const scrollToNextElement = (destinationIdx = null) => {
        // default to "fissa" button
        let destinationNode = document.querySelector(".btn-txt-container");
        if (null != destinationIdx) {
            destinationNode = document.querySelectorAll(".tos-item-component__header input[type=radio]")[destinationIdx];
        }
        destinationNode.scrollIntoView({
            behavior: "smooth",
            block: "center",
        });
    };

    const [consensiModalStartIndex, setConsensiModalStartIndex] = useState(0);
    const [openConsensiModal, setOpenConsensiModal] = useState(false);
    const consensiModalSplide = useRef();

    return (
        <>
            <div className="section tos-list-component">
                <h3>{t("we_need_your_consent_1")}</h3>
                <br />
                <p className="" dangerouslySetInnerHTML={{ __html: t("prendi_visione") }}></p>

                <div className={`section white-box input-box-component`}>
                    <p className="crea-appto-error tos-list-component-appto-error text-center hidden">Devi rispondere a tutti i punti sotto elencati.</p>

                    {informative.map((itm, idx) => {
                        return (
                            <>
                                {idx == 3 && (
                                    <p className="crea-appto-error tos-list-component-sic-appto-error text-center hidden">
                                        <br />È obbligatorio il consenso.
                                    </p>
                                )}
                                <Consenso
                                    key={`consenso-out-${idx}`}
                                    defaultValue={read(`${itm["name"]}`)}
                                    onChange={(value) => {
                                        update(`${itm["name"]}`, value);
                                        scrollToNextElement(idx < 3 ? (idx + 1) * 2 : null);
                                    }}
                                    name={itm["name"]}
                                    textPreview={itm["textPreview"]}
                                    classList={idx == 3 ? "tos-sic" : ""}
                                    onInfoIconClick={() => {
                                        setConsensiModalStartIndex(idx);
                                        setOpenConsensiModal(true);
                                    }}
                                />
                                {idx < 3 && <hr />}
                            </>
                        );
                    })}
                </div>
            </div>

            {openConsensiModal && (
                <div id="consensi-modal" className={`modal-component modal-container ${openConsensiModal ? "open" : ""}`}>
                    <div
                        onClick={() => {
                            setOpenConsensiModal(false);
                        }}
                        className="modal-backdrop"></div>

                    <div className="modal-content">
                        <div
                            onClick={() => {
                                setOpenConsensiModal(false);
                            }}
                            className="close-modal-icon modal-element text-right">
                            <img className="clickable" src={closeIcon} />
                        </div>

                        <div className={`section white-box input-box-component`}>
                            <Splide options={{ arrows: false, start: consensiModalStartIndex }} ref={consensiModalSplide}>
                                {informative.map((itm, idx) => (
                                    <SplideSlide>
                                        <div className="consensi-modal-content">
                                            <h3>{itm.textModalTitle}</h3>
                                            <p dangerouslySetInnerHTML={{ __html: itm.textModalPreCheck }}></p>
                                            <div>
                                                <Consenso
                                                    key={`consenso-in-${idx}`}
                                                    defaultValue={read(`${itm["name"]}`)}
                                                    onChange={(value) => {
                                                        update(`${itm["name"]}`, value);
                                                        // consensiModalSplide.current.go('>');
                                                        setOpenConsensiModal(false);
                                                    }}
                                                    name={`${itm["name"]}-modal`}
                                                />
                                            </div>
                                            <p dangerouslySetInnerHTML={{ __html: itm.textModalPostCheck }}></p>
                                        </div>
                                    </SplideSlide>
                                ))}
                            </Splide>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
